import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import css from 'page/StartScreen/combine/item/MainCard.module.scss'
import { renderItemTitle } from 'shared/item/title'
import { Item } from 'type/Item'

type Props = {
  item: Item
}

export const MainCard = observer(({ item }: Props) => {
  const image = item.item_combo_image || item.item_full_image
  const title = renderItemTitle(item)

  return (
    <Space className={css.root} gap={12}>
      <Space className={css.image}>{image && <Image src={image} />}</Space>
      <Vertical gap={8}>
        <Typo size={13}>{i18n('MainItem')}</Typo>
        {title}
      </Vertical>
    </Space>
  )
})
